import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

export const Marquee = () => {
  const [position, setPosition] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prev) => (prev - 1) % 100);
    }, 30);
    return () => clearInterval(interval);
  }, []);

  const text = "RELIABLE • PROFESSIONAL • TRUSTED • DETAILED • ";
  const repeatedText = text.repeat(10);

  return (
    <div className="py-12 bg-gradient-to-r from-teal-600 via-cyan-600 to-teal-600 overflow-hidden">
      <motion.div
        className="whitespace-nowrap"
        style={{ transform: `translateX(${position}%)` }}
      >
        <span className="text-6xl md:text-8xl font-bold text-white/20">
          {repeatedText}
        </span>
      </motion.div>
    </div>
  );
};
